import { EventTypes } from '../types';
import { CollectionsLobbyBigQueryEvents } from '../../../../page/collections_lobby/utils/events/bigQuery';
import { CollectionPageBigQueryEvents } from '../../../../page/collection_page/utils/events/bigQuery';
import { createTechnicalBigQueryEvent } from './technical';

const { collection } = EventTypes.shared;

export const BigQueryEvents = {
    ...CollectionsLobbyBigQueryEvents,
    ...CollectionPageBigQueryEvents,

    [collection.create.success]: createTechnicalBigQueryEvent('list.created'),
    [collection.update.success]: createTechnicalBigQueryEvent('list.edit'),
    [collection.delete.success]: createTechnicalBigQueryEvent('list.deleted'),
    [collection.shareWithTeam.success]: createTechnicalBigQueryEvent('list.team_invited'),
};
